function followShopAnchor() {
  const anchor = location.hash.slice(1);
  if (anchor === 'trader-originals' || anchor === 'shop') {
    const catalog = document.getElementById('shop');
    const filter = catalog?.querySelector(`[data-collection="${anchor === 'trader-originals' ? 'originals' : 'all'}"]`);
    filter?.click();
    if (anchor === 'trader-originals') catalog?.scrollIntoView({block:'start'});
  }
  const detail = document.getElementById(anchor);
  if (detail?.matches('details')) { detail.open = true; detail.scrollIntoView({block:'start'}); }
}
window.addEventListener('hashchange', followShopAnchor);
document.addEventListener('click', e => {
  const link = e.target.closest('a[href]');
  if (!link) return;
  const url = new URL(link.href, location.href);
  if (url.origin === location.origin && url.pathname === location.pathname && url.hash === location.hash) followShopAnchor();
});
followShopAnchor();
